// Import
import html2pdf from "html2pdf.js";
/**
 *
 * @param node HTMLElement which contains the action
 * @param nodeId the id of the element which need to export
 * @returns
 */
export function html2pdfAction(node, nodeId) {
    // Create and add the button at the button
    const button = node.ownerDocument.createElement("Button");
    button.textContent = 'PDF';
    node.appendChild(button);
    // Handling the button by
    const handleExportToPDF = () => {
        // Call the lib
        html2pdf().from(node.ownerDocument.getElementById(nodeId)).save();
        // The lib directly export
    };
    // Listen to click
    button.addEventListener('click', handleExportToPDF);
    return {
        // Important to avoid keeping references
        destroy() {
            button.removeEventListener('mousedown', handleExportToPDF);
        }
    };
}
/**
 *
 * @param node HTMLElement which contains the action
 * @param nodeId the id of the element which need to export
 * @returns
 */
export function html2pdfActionButton(node, nodeId) {
    // Create and add the button at the button
    const button = node;
    // Change style
    button.style.backgroundColor = "var(--primary-color)";
    button.style.color = "var(--primary-contrast)";
    button.style.fontWeight = "bold";
    button.style.border = "0";
    button.style.borderRadius = "8px";
    button.style.width = "100px";
    button.style.height = "40px";
    button.style.cursor = "pointer";
    // Handling the button by
    const handleExportToPDF = () => {
        // Call the lib
        html2pdf().from(node.ownerDocument.getElementById(nodeId)).save();
        // The lib directly export
    };
    // Listen to click
    button.addEventListener('click', handleExportToPDF);
    return {
        // Important to avoid keeping references
        destroy() {
            button.removeEventListener('mousedown', handleExportToPDF);
        }
    };
}
